import { render, staticRenderFns } from "./byTrend.vue?vue&type=template&id=1a6dc086&scoped=true"
import script from "./byTrend.vue?vue&type=script&lang=js"
export * from "./byTrend.vue?vue&type=script&lang=js"
import style0 from "./byTrend.vue?vue&type=style&index=0&id=1a6dc086&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6dc086",
  null
  
)

export default component.exports